package exception

class EmptyProjectException : Throwable("This format could not take en empty project.")
